module.exports = __webpack_public_path__ + "static/img/d_mzjg_icon.png";